<template>
  <GenericStep v-bind="$attrs">
    <div
      v-for="immigration_status of peParty.immigration_statuses"
      :key="immigration_status.id"
      class="mb-12"
    >
      <ImmigrationStatusCard
        :item="immigration_status"
      />
    </div>

    <SectionAdderLine
      section="Immigration Status"
      :has-new-section="peImmigrationStatusCardHasNewSection"
      @on-add="peImmigrationStatusCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import ImmigrationStatusCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/ImmigrationStatusCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'ImmigrationStatusStep',

  components: {
    GenericStep,
    ImmigrationStatusCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.immigration_statuses
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peImmigrationStatusCardHasNewSection',
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peImmigrationStatusCardAddSection',
    ]),
  },
}
</script>
